export default "__VITE_ASSET__DXfEfNqR__"